import i18n from '@/lib/i18n';
import { ContentCreatorCourse, CourseFormatEnum } from '@/models/Course';
import User from '@/models/User';

const getFormatAbbreviation = (format: CourseFormatEnum): string => {
  const schoolFormat = i18n.t('school')?.charAt(0);

  const selfPacedFormats =
    i18n.t(`courseFormats.${format}`).toUpperCase().match(/\b\w/g)?.join('') ||
    '';

  const formats: {
    [key in CourseFormatEnum]: string;
  } = {
    IN_PERSON: 'P',
    ONLINE: 'O',
    SCHOOL: schoolFormat,
    EXTRA_COURSE: selfPacedFormats,
    SELF_PACED: selfPacedFormats,
  };

  return formats[format];
};

export function nameAndFormats(name: string, formats: CourseFormatEnum[]) {
  const abbreviations = formats?.map(getFormatAbbreviation).join('/') || '';
  return `${abbreviations} - ${name}`;
}

export function segregateToCreateAndDelete(
  origin: ContentCreatorCourse[],
  change: number[],
) {
  const toDelete = origin.filter(
    contentCreateCourses => !change.includes(contentCreateCourses.course.id),
  );

  const toCreate = change.filter(
    courseIdChange =>
      !origin.some(
        contentCreateCourses =>
          contentCreateCourses.course.id === courseIdChange,
      ),
  );

  return { toDelete, toCreate };
}

export const createContentCreatorCourses = (user: User, courses: number[]) => {
  return courses.map(courseId => ({
    courseId,
    contentCreatorId: user.id,
  }));
};
